import app from '../app/index';
export default {
    install: (Vue) => {
        Vue.prototype.$JD = app;
    }
}
